













import Vue from 'vue';

export default Vue.extend({
  methods: {
    onClose(): void {
      this.$store.commit('setDevelopmentPopup', false);
    },
  },
});
